<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Gebied</label> 
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="area_po" type="radio" name="area" [(ngModel)]="item['area']" [value]="'po'"> 
                        <label class="form-check-label" for="area_po">Primair onderwijs</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="area_vo" type="radio" name="type" [(ngModel)]="item['area']" [value]="'vo'"> 
                        <label class="form-check-label" for="area_vo">Voortgezet onderwijs</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Naam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['name']}"
                    type="text" 
                    [(ngModel)]="item['name']" 
                    class="form-control" 
                    placeholder="">
            </div>
            <div class="col-6">
                <label class="form-label">Prefix</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['prefix']}"
                    type="text" 
                    [(ngModel)]="item['prefix']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>

        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="item['id']">Toevoegen</span>
                <span *ngIf="!item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>